import React, { useEffect, useState } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';

import { basic } from '../request/values';
import { COLORS } from '../shared/Theme';
import TitleBar from '../shared/header/TitleBar';

const useStyles = makeStyles((theme) => ({
	page: {
		height: '100%',
		boxSizing: 'border-box',
		background: COLORS.WHITE,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		padding: '10px 3vw 0',
		[theme.breakpoints.up('md')]: {
			padding: '28px 32px 0',
		},
	},
	body: {
		flex: 1,
		minHeight: 0,
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'center',
		padding: '8px 0 28px',
		overflowY: 'auto',
		WebkitOverflowScrolling: 'touch',
		[theme.breakpoints.up('md')]: {
			alignItems: 'center',
			padding: '12px 0 28px',
		},
	},
	panel: {
		width: '100%',
		maxWidth: 420,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 20,
		padding: '28px 22px',
		borderRadius: 16,
		border: '1px solid #E5EAF0',
		background: COLORS.WHITE,
		boxShadow: '0 8px 28px rgba(18, 145, 217, 0.08)',
		[theme.breakpoints.up('md')]: {
			maxWidth: 480,
			gap: 24,
			padding: '40px 36px',
			borderRadius: 18,
		},
	},
	label: {
		fontFamily: 'NanumB',
		fontWeight: 700,
		fontSize: 13,
		letterSpacing: '0.02em',
		color: '#90A4B8',
	},
	code: {
		fontFamily: 'NanumB',
		fontWeight: 800,
		fontSize: '2rem',
		lineHeight: 1.2,
		letterSpacing: '0.12em',
		color: COLORS.WATER_BLUE,
		textAlign: 'center',
		wordBreak: 'break-all',
		[theme.breakpoints.up('md')]: {
			fontSize: '2.4rem',
			letterSpacing: '0.14em',
		},
	},
	hint: {
		fontFamily: 'NanumR',
		fontSize: 14,
		lineHeight: 1.5,
		color: '#6B7785',
		textAlign: 'center',
		maxWidth: 320,
		[theme.breakpoints.up('md')]: {
			fontSize: 15,
			maxWidth: 360,
		},
	},
	qrWrap: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: 18,
		borderRadius: 14,
		background: COLORS.WHITE,
		border: '1px solid #E5EAF0',
		[theme.breakpoints.up('md')]: {
			padding: 24,
			borderRadius: 16,
		},
	},
	qrCode: {
		width: 168,
		height: 168,
		display: 'block',
		[theme.breakpoints.up('md')]: {
			width: 220,
			height: 220,
		},
	},
	empty: {
		fontFamily: 'NanumB',
		fontWeight: 700,
		fontSize: 15,
		color: '#90A4B8',
		textAlign: 'center',
		padding: '40px 16px',
	},
}));

const OperClassCode: React.FC<any> = () => {
	const classes = useStyles();
	const { t } = useTranslation('oper');
	const [classCode, setClassCode] = useState<string>('');

	useEffect(() => {
		const member = localStorage.getItem('member');
		if (member) {
			const memberData = JSON.parse(member);
			if (memberData.classCode && memberData.classCode !== '') {
				setClassCode(memberData.classCode);
				return;
			}
		}
	}, []);

	return (
		<div className={classes.page}>
			<TitleBar title={t('OperClassCode.title')} titleIcon="order" />
			<div className={classes.body}>
				{classCode ? (
					<div className={classes.panel}>
						<div className={classes.label}>{t('OperClassCode.codeLabel')}</div>
						<Typography className={classes.code} data-testid="oper-class-code">
							{classCode}
						</Typography>
						<Typography className={classes.hint}>{t('OperClassCode.hint')}</Typography>
						<div className={classes.qrWrap}>
							<QRCode className={classes.qrCode} value={`${basic.base_url}/classEnter?classCode=${classCode}`} />
						</div>
					</div>
				) : (
					<div className={classes.empty}>{t('OperClassCode.empty')}</div>
				)}
			</div>
		</div>
	);
};

export default OperClassCode;
